import React from 'react';
import {
  ICON_BUTTON_SIZE_TB,
  ICON_BUTTON_SIZE_XS,
  IconButton,
  TOOLTIP_PLACEMENT_BOTTOM,
  type TooltipPlacement,
} from '@aibuild/ui';
import { usePortalContainer } from '../environment';
import { useChromeLayout } from './ChromeContext';

export interface ChromeButtonProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  pressed?: boolean;
  /** Disables the button and says why in its tooltip. */
  disabledReason?: string;
  tooltipPlacement?: TooltipPlacement;
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>;
  testId: string;
}

/** A viewer toolbar button: a toggle when `pressed` is given, sized for the viewer's width. */
const ChromeButton = React.forwardRef<HTMLButtonElement, ChromeButtonProps>(function ChromeButton(
  {
    label,
    icon,
    onClick,
    pressed,
    disabledReason,
    tooltipPlacement = TOOLTIP_PLACEMENT_BOTTOM,
    onMouseDown,
    testId,
  },
  ref,
) {
  const portal = usePortalContainer();
  const { narrow } = useChromeLayout();
  return (
    <IconButton
      ref={ref}
      ariaLabel={label}
      icon={icon}
      tooltip={disabledReason ?? label}
      tooltipPlacement={tooltipPlacement}
      tooltipPortalContainer={portal}
      size={narrow ? ICON_BUTTON_SIZE_XS : ICON_BUTTON_SIZE_TB}
      pressed={pressed}
      disabled={disabledReason !== undefined}
      onClick={onClick}
      onMouseDown={onMouseDown}
      dataTestId={testId}
    />
  );
});

export default ChromeButton;
